// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"d097f76f","538":"23075a7e"}[chunkId] + ".chunk.js";
};